import { Typography } from '@weareopenr/component-library';
import styles from './DashboardSectionHeader.module.scss';

export const DashboardSectionHeader = ({ title, children }: { title: string; children?: React.ReactNode }) => {
  return (
    <div className={styles['section-heading']}>
      <div className={styles['left-content']}>
        <Typography size="xlarge" weight="semi-bold">
          {title}
        </Typography>
      </div>
      <div className={styles['right-content']}>{children}</div>
    </div>
  );
};
